// extracted by mini-css-extract-plugin
export default {"executors":"task__task-right-menu__components__task-participants__executors"};